export enum AuthStatus {
    PENDING,
    SUCCESS,
    FAILED,
}
